module.exports = __webpack_public_path__ + "img/documents.46c92acd.jpg";